module.exports = "https://assets.pclncdn.com/web/next-landing/b8f04f44e5/_next/static/images/Three-a112201b65eb30d1dfecbdd118ebcc92.svg";